<template>
  <div class="quizz">
    <div class="launcher" id="quizz-content">
      <div @click="app.displaySettings()" id="boule" class="new-boule"><svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30"  style="fill: rgb(128, 151, 13);"><path d="M130.001-254.616V-300h699.998v45.384H130.001Zm0-202.692v-45.384h699.998v45.384H130.001Zm0-202.692v-45.384h699.998V-660H130.001Z"/></svg></div>
      <h1>Peintures</h1>
      <div id="quizz-selector">
        <img id="line" class="line" src="line.png">
        <div id="all-btns" v-for="quizz in app.data[app.currentMusee].collections[0].quizz.filter(x => x.level == app.currentLevel)" :key="quizz" @click="app.setQuizz(quizz.id)">
          <button @click="app.closeQuizz">
            <img :src="quizz.mediaStart" />
            <p>{{quizz.name}}</p>
          </button>
          <div class="gradient"></div>
        </div>
      </div>
      
    </div>

    <question
      v-bind:app="app"
    ></question>
    
    <settings
      v-bind:app="app"
    ></settings>

    
  </div>
</template>

<script>
import question from './question.vue';
import settings from './settings.vue';

export default {
  name: 'QuizzVue',
  props: {
    app:Object
  },
  components :{
    question,
    settings
  }
}
</script>


